import { PlayerMetricHeuristic } from '../../jscaip/AI/PlayerMetricHeuristic';
import { Player } from '../../jscaip/Player';
import { PlayerNumberTable } from '../../jscaip/PlayerNumberTable';
import { KamisadoRules } from './KamisadoRules';
export class KamisadoHeuristic extends PlayerMetricHeuristic {
    getMetrics(node, _config) {
        const state = node.gameState;
        // Metric is how far a player's piece is from the end line
        const furthest = KamisadoRules.getFurthestPiecePositions(state);
        return PlayerNumberTable.ofSingle(7 - furthest.get(Player.ZERO), furthest.get(Player.ONE));
    }
}
